import { FileStoreLayout } from "#/file-store/components/FileStoreLayout";

const FileStorePage = () => {
  return <FileStoreLayout />;
};

export default FileStorePage;
